import React, {
  useState,
  useCallback,
} from 'react';
import {
  Table,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
} from '@mui/material';
import {makeStyles} from "@mui/styles";

import {
  Button,
  EnhancedTableHead,
} from "../";
import {reduceText, sortOrder} from '../../lib';
import Registration from './Registration';

const headCells = [
  { id: 'name', sortable: true, label: '장소명' },
  { id: 'addressBase', sortable: false,  label: '주소' },
  { id: 'phone', sortable: false,  label: '연락처' },
  { id: 'placeInfo', sortable: false,  label: '장소 정보 및 특이사항' },
  { id: 'edit', sortable: false,  label: '수정 | 삭제' },
];

const useStyles = makeStyles(() => ({
  pagination: {
    flexShrink: 0,
  },

  buttonDelete: {
    marginLeft: 10,
  },
}));


export default function Content(props: any) {
  const classes = useStyles();
  const { addressBook, refresh, deleteAddress } = props;

  const [address, setAddress] = useState<any | null>(null);
  const [orderType, setOrderType] = useState<string>('desc');
  const [orderBy, setOrderBy] = useState<string>('createdAt');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handleRequestSort = useCallback((event: any, property: any) => {
    const isAsc = orderBy === property && orderType === 'asc';
    setOrderType(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  }, [orderType, orderBy, setOrderType, setOrderBy]);

  const handleChangePage = useCallback(
    (e, newPage) => {
      setPage(newPage);
    },
    [setPage]
  );

  const handleChangeRowsPerPage = useCallback(
    (e) => {
      setRowsPerPage(e.target.value);
      setPage(0);
    },
    [setRowsPerPage]
  );

  return (
    <div>
      {address && <Registration address={address} refresh={refresh} close={() => setAddress(null)} />}
      <Table>
        <EnhancedTableHead
          classes={classes}
          orderBy={orderBy}
          orderType={orderType}
          onRequestSort={handleRequestSort}
          headCells={headCells}
        />
        <TableBody>
          { addressBook &&
            addressBook.sort(sortOrder(orderType, orderBy))
              .map((a: any, i: number) => (
              <TableRow key={i}>
                <TableCell>{a.name}</TableCell>
                <TableCell>{a.addressBase + ' ' + a.addressDetail}</TableCell>
                <TableCell>{a.phone}</TableCell>
                <TableCell>{reduceText(a.placeInfoForCustomer, 20)}</TableCell>
                <TableCell>
                  <Button onClick={() => { setAddress(a) }}>
                    수정
                  </Button>
                  <Button
                    className={classes.buttonDelete}
                    color="error"
                    onClick={async () => {
                      if (window.confirm("해당 주소를 삭제하시겠습니까?")) {
                        await deleteAddress(a.id);
                        await refresh();
                      }
                    }}
                  >
                    삭제
                  </Button></TableCell>
              </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={addressBook.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        className={classes.pagination}/>
    </div>
  )
}